'use client';

import React from 'react';

interface Audience {
  title: string;
  description: string;
}

const AudienceSection = () => {
  const audiences: Audience[] = [
    {
      title: 'Senior Leaders and Boards',
      description: 'For executives and board members seeking to steward AI-driven change, govern continuous transformation, and build long-term organisational capability rather than manage discrete technology projects.',
    },
    {
      title: 'Enterprises Adopting AI at Scale',
      description: 'For organisations moving beyond pilots to enterprise-wide AI adoption, requiring leadership frameworks and systems to sustain transformation momentum.',
    },
    {
      title: 'Partners Seeking Adoption Standards',
      description: 'For consultancies, system integrators, and technology providers seeking cross-industry standards and practices for AI adoption and change leadership.',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-6 leading-tight">
              Who This Is For
            </h2>
          </div>

          {/* Audiences */}
          <div className="space-y-8">
            {audiences.map((audience, index) => (
              <div key={index} className="border-l-4 border-[#0A2540] pl-8 py-4">
                <h3 className="text-2xl font-bold font-headline text-[#0A2540] mb-3">
                  {audience.title}
                </h3>
                <p className="text-lg text-gray-700 font-body leading-relaxed">
                  {audience.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;